import type React from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import { AthleteSignupForm } from '../components/auth/AthleteSignupForm'
import { theme } from '../theme/theme'

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${theme.spacing.md};
`

const AthleteSignupPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const coachId = searchParams.get('coach')

  if (!coachId) {
    return (
      <PageContainer>
        <div style={{ textAlign: 'center', color: 'red' }}>
          Invalid invitation link. Please contact your coach for a new invite.
        </div>
      </PageContainer>
    )
  }

  const handleSignupComplete = () => {
    // After successful signup, redirect to login page
    /*
    setTimeout(() => {
      navigate('/login')
    }, 3000)
     */
  }

  return (
    <PageContainer>
      <AthleteSignupForm coachId={coachId} onSignupComplete={handleSignupComplete} />
    </PageContainer>
  )
}

export default AthleteSignupPage
